class FJAppConfig {
    constructor(props) {
        // 链接中的字段
        this._urlKey = props.urlKey;
        this._type = props.type;
        this._config = props.config;
    }

    get urlKey() {
        return this._urlKey;
    }

    get type() {
        return this._type;
    }

    get config() {
        return this._config;
    }
}

export default FJAppConfig;
